import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  UploadCarouselImageRequest,
  UploadCarouselImageResponse,
} from "@punchup/data/models";
import { uploadCarouselImage, CAROUSEL_QUERY_KEY } from "./api";

interface UploadCarouselImageParams {
  venuePageId: string;
  data: UploadCarouselImageRequest;
}

/**
 * Hook to upload a new image to the carousel
 */
export function useUploadCarouselImage(): UseMutationResult<
  UploadCarouselImageResponse,
  Error,
  UploadCarouselImageParams
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ venuePageId, data }: UploadCarouselImageParams) =>
      uploadCarouselImage(venuePageId, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [CAROUSEL_QUERY_KEY, variables.venuePageId],
      });
    },
  });
}
